module.exports = __webpack_public_path__ + "static/media/corbusville-01.855a9c23.png";